import { rightLanguage } from "@/sharedTypes/helpers";
import { Fzf } from "fzf";

export default class SamplesFinder {
  fzf: any = null;
  samples: any[] = [];

  constructor(samples: any[]) {
    this.samples = samples;

    // Create a search that includes both title and category
    this.fzf = new Fzf(samples, {
      selector: sample => {
        return `${rightLanguage(sample.category)} ${rightLanguage(sample.metadata.title)}`;
      },
      casing: 'case-insensitive',
    });
  }

  search(query: string) {
    if (!query || query.trim().length === 0) {
      return this.samples;
    }

    const searchQuery = query.trim().toLowerCase();

    return this.samples.filter(sample => {
      const text = `${rightLanguage(sample.category)} ${rightLanguage(sample.metadata.title)}`.toLowerCase();
      
      // Simple substring search - what you see is what you get
      return text.includes(searchQuery);
    });
  }
}
